<div style="position:relative;" (click)="handleClickEventForImplementingModalHack()" [ngStyle]="changeStyle1()">

  <ngx-ui-loader   ></ngx-ui-loader>
  <div style="display: flex;" [ngStyle]="changeStyle()">
    <router-outlet></router-outlet>
  </div>
  <div class="help-Popup" [ngStyle]="{'z-index':airportModalOpen() ? '0':'1100'}">
    @if ((this.isMobile1 && isuserHascard()) || !njoySpecificBuild) {
      <app-help-popup></app-help-popup>
    }
  </div>
  <app-footer></app-footer>
  <app-remote-auth-modal></app-remote-auth-modal>
</div>
@if (groupTimerSvc.state$ | async; as timer) {
  @if (!isGroupBookingOnHotelPage()) {
    <div class="gbk-global-timer">
      <div class="gbk-global-timer-rooms">{{timer.securedRooms}}/{{timer.roomsNeeded}} rooms secured</div>
      <div class="gbk-global-timer-divider"></div>
      <div class="gbk-global-timer-countdown">
        <span class="gbk-global-timer-label">Hold expires in</span>
        <span class="gbk-global-timer-value">{{groupTimerSvc.formatTime(timer.remainingSeconds)}}</span>
      </div>
    </div>
  }
}
@if (groupBookingHoldGuard.showLeaveReleaseModal) {
  <div class="group-booking-modal-overlay" (click)="groupBookingHoldGuard.cancelLeave()">
    <div class="group-booking-modal" (click)="$event.stopPropagation()">
      <div class="group-booking-modal-title">{{'hotelSelect.LeaveReleaseModalTitle' | translate}}</div>
      <div class="group-booking-modal-body">
        {{'hotelSelect.LeaveReleaseModalBody' | translate: { count: groupBookingHoldGuard.getHeldRoomCount() } }}
      </div>
      <div class="group-booking-modal-actions">
        <button class="btn primary-button" (click)="groupBookingHoldGuard.cancelLeave()">
          {{'hotelSelect.StayOnPage' | translate}}
        </button>
        <button type="button" class="btn-danger-outline" (click)="groupBookingHoldGuard.confirmLeaveAndRelease()">
          {{'hotelSelect.LeaveAndReleaseRooms' | translate}}
        </button>
      </div>
    </div>
  </div>
}
@if (this.currDatePicker!==null && (isMobile && !isDashboardPage())) {
  <div class="calendar-close-icon"
    (click)="closeCalendar()">
    <i class="material-icons">close</i>
  </div>
}